import { useAxios, useSubjectMember } from '@healthblocks-io/core'
import { useRecoilState } from 'recoil'

import { pendingTaskCountAtom } from '../state/task.atom'

export function usePendingTaskCount() {
  const [pendingTaskCount, setPendingTaskCount] = useRecoilState(pendingTaskCountAtom)

  const axios = useAxios()
  const subjectMember = useSubjectMember()

  const checkPendingTaskCount = async () => {
    try {
      if (!subjectMember?.id) {
        throw new Error('Subject member not found')
      }

      const response = await axios.get<{ count: number }>(`/task/count?subjectId=${subjectMember?.id}`)
      const newCount = response.data.count
      setPendingTaskCount(newCount)
    } catch (error) {
      console.error(error)
    }
  }

  const resetPendingTaskCount = async () => {
    setPendingTaskCount(0)
  }

  return { checkPendingTaskCount, pendingTaskCount, resetPendingTaskCount }
}
